import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/iconite/locatie.png'


const _withScopeId = n => (_pushScopeId("data-v-4f256851"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-lg ecran-container" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_3 = {
  key: 0,
  class: "app__page__title__container"
}
const _hoisted_4 = {
  class: "app__page__title",
  style: {"white-space":"nowrap"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"position":"relative","width":"24px","height":"28px"}
}, null, -1))
const _hoisted_6 = { style: {"margin":"auto"} }
const _hoisted_7 = { style: {"margin-left":"auto","display":"flex","align-items":"center"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Sterge filtre! ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "q-pa-lg flex flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_pagination = _resolveComponent("q-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$q.platform.is.desktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.admin_delivery_addresses')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_q_btn, {
          "no-caps": "",
          style: {"background-color":"#9b7d32","color":"white"},
          onClick: _ctx.syncronizeApollo,
          loading: _ctx.loadingApollo
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('message.manage_items_apollo')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_q_btn, {
          icon: "restart_alt",
          flat: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshFilters()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tooltip, {
              anchor: "top middle",
              self: "bottom middle",
              offset: [10, 10],
              "transition-show": "scale",
              "transition-hide": "scale"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_input, {
          "bottom-slots": "",
          debounce: "300",
          modelValue: _ctx.filterText,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterText) = $event)),
          dense: ""
        }, {
          append: _withCtx(() => [
            (_ctx.filterText !== '')
              ? (_openBlock(), _createBlock(_component_q_icon, {
                  key: 0,
                  name: "close",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterText = '')),
                  class: "cursor-pointer"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_q_icon, { name: "search" })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _hoisted_9,
    _createVNode(_component_q_table, {
      grid: _ctx.$q.platform.is.mobile,
      class: "my-sticky-header-table",
      title: "",
      "rows-per-page-options": [10],
      pagination: _ctx.pagination,
      "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pagination) = $event)),
      rows: _ctx.companies,
      columns: _ctx.columns,
      "visible-columns": _ctx.visibleColumns,
      "row-key": "denumire",
      flat: "",
      bordered: "",
      "no-data-label": _ctx.$t('message.no_data')
    }, {
      body: _withCtx((props) => [
        _createVNode(_component_q_tr, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_q_td, {
              key: "company",
              props: props,
              style: {"vertical-align":"top","margin-top":"16px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.denumire), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "addresses",
              props: props,
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.addresses, (address) => {
                  return (_openBlock(), _createBlock(_component_q_tr, {
                    loading: "loadingAddresses",
                    key: address.slid,
                    style: {"width":"100%","text-decoration":"none"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_td, {
                        style: _normalizeStyle(address.isNewAddress == '1' ? 'color:#C7C7C7; width:100%;text-decoration: none;' : 'color:black; width:100%;text-decoration: none;')
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(address.adresaAdresa) + ", " + _toDisplayString(address.adresaLocalitate) + ", " + _toDisplayString(address.denJudet) + " " + _toDisplayString(address.codTara) + " " + _toDisplayString(address.isNewAddress == '1' ? ' - ' + _ctx.$t('message.approval_address_sales') : ''), 1)
                        ]),
                        _: 2
                      }, 1032, ["style"]),
                      _createVNode(_component_q_td, null, {
                        default: _withCtx(() => [
                          (address.isNewAddress == '1')
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 0,
                                style: {"background-color":"#9b7d32","color":"white"},
                                flat: "",
                                onClick: ($event: any) => (_ctx.approveAddress(address)),
                                "no-caps": "",
                                "no-wrap": "",
                                dense: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    left: "",
                                    name: "task_alt",
                                    class: "material-symbols-outlined"
                                  }),
                                  _createVNode(_component_q_tooltip, {
                                    anchor: "top middle",
                                    self: "bottom middle",
                                    offset: [10, 10],
                                    "transition-show": "scale",
                                    "transition-hide": "scale"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('message.approve_address')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_td, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_btn, {
                            color: "red",
                            flat: "",
                            onClick: ($event: any) => (_ctx.deleteAdresa(address)),
                            "no-caps": "",
                            "no-wrap": "",
                            dense: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_icon, {
                                left: "",
                                name: "delete_forever"
                              }),
                              _createVNode(_component_q_tooltip, {
                                anchor: "top middle",
                                self: "bottom middle",
                                offset: [10, 10],
                                "transition-show": "scale",
                                "transition-hide": "scale"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('message.delete')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      _: 1
    }, 8, ["grid", "pagination", "rows", "columns", "visible-columns", "no-data-label"]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_q_pagination, {
        modelValue: _ctx.currentPage,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentPage) = $event)),
        max: _ctx.totalNumberOfPages,
        input: ""
      }, null, 8, ["modelValue", "max"])
    ])
  ]))
}